module.exports = __webpack_public_path__ + "static/img/top-img-HD.e6bd3ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/top-img-HD.jpg
// module id = 0JHI
// module chunks = 52